import React, { useId, useRef } from 'react';

const Input = ({ label, error, className = '', id: providedId, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, ...props }) => {
  const generatedId = useId();
  const inputRef = useRef(null);
  const inputId = providedId || `input-${generatedId}`;
  const errorId = `${inputId}-error`;
  const describedBy = error
    ? Array.from(new Set(`${ariaDescribedBy || ''} ${errorId}`.trim().split(/\s+/).filter(Boolean))).join(' ')
    : ariaDescribedBy;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="mb-2 block text-xs uppercase tracking-[0.24em] text-muted"
          onClick={() => {
            if (!props.disabled) inputRef.current?.focus();
          }}
        >
          {label}
        </label>
      )}
      <input
        ref={inputRef}
        id={inputId}
        aria-describedby={describedBy}
        aria-invalid={error ? true : ariaInvalid}
        className={`w-full rounded-2xl border border-line bg-surface px-4 py-3 text-base text-ink outline-none focus:ring-2 focus:ring-accent ${className} ${
          error ? '!border-red-500 !bg-red-500/5 !ring-2 !ring-red-500/30' : ''
        }`}
        {...props}
      />
      {error && <p id={errorId} role="alert" className="mt-2 text-sm text-accent">{error}</p>}
    </div>
  );
};

export default Input;
